export const DIALOG_CUSTOMER = 'DIALOG_CUSTOMER';
export const DIALOG_EDIT_CUSTOMER = 'DIALOG_EDIT_CUSTOMER';
